import { FETCH_CUSTOMER_PROFILE, RECONCILE_WALLET_BALANCE } from 'actions/customer';

const initialState = {
  isLoading: false,
  isReconciling: false,
  customerProfile: {},
};
const customerProfileReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_CUSTOMER_PROFILE.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_CUSTOMER_PROFILE.SUCCESS: {
      return {
        ...state,
        customerProfile: payload,
        isLoading: false,
      };
    }

    case FETCH_CUSTOMER_PROFILE.FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case RECONCILE_WALLET_BALANCE.REQUEST: {
      return { ...state, isReconciling: true };
    }

    case RECONCILE_WALLET_BALANCE.SUCCESS: {
      return { ...state, isReconciling: false };
    }

    case RECONCILE_WALLET_BALANCE.FAIL: {
      return { ...state, isReconciling: false };
    }

    default:
      return { ...state };
  }
};
export default customerProfileReducer;
